
document.addEventListener("DOMContentLoaded", () => {

  const animatedElements = document.querySelectorAll(".intersect-animate");
  const animatedCenterElements = document.querySelectorAll(".intersect-animate-center");
  const animated30Elements = document.querySelectorAll(".intersect-animate-30");

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // console.log(entry.target);
      // console.log(`Visible: ${(entry.intersectionRatio * 100).toFixed(0)}%`);
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        // Optional: stop observing once animation is triggered
        // observer.unobserve(entry.target);
        if (entry.intersectionRatio >= 1) {
          entry.target.classList.remove('seventyfive', 'fifty', 'twentyfive');
          entry.target.classList.add('full');
        } else if (entry.intersectionRatio >= 0.75) {
          entry.target.classList.remove('full', 'fifty', 'twentyfive');
          entry.target.classList.add('seventyfive');
        } else if (entry.intersectionRatio >= 0.5) {
          entry.target.classList.remove('full', 'seventyfive', 'twentyfive');
          entry.target.classList.add('fifty');
        } else if (entry.intersectionRatio >= 0.25) {
          entry.target.classList.remove('full', 'seventyfive', 'fifty');
          entry.target.classList.add('twentyfive');
        } else {
          entry.target.classList.remove('full', 'seventyfive', 'fifty', 'twentyfive');
        }
      } else {
        entry.target.classList.remove('in-view');
      }
    });
  }, {     
    root: null,
    rootMargin: '100px',
    threshold: [0, 0.25, 0.5, 0.75, 1] 
  });

  const observerCenter = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
      } else {
        entry.target.classList.remove('in-view');
      }
    });
  }, {     
    root: null,
    rootMargin: '0% 0% -50% 0%',
    threshold: 0 
  });

  const observer30 = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
      } else {
        entry.target.classList.remove('seen');
        entry.target.classList.remove('in-view');
      }
    });
  }, {     
    root: null,
    rootMargin: '0% 0% -30% 0%',
    threshold: 0 
  });

  animatedElements.forEach(section => {
    observer.observe(section);
  });

  animatedCenterElements.forEach(section => {
    observerCenter.observe(section);
  });
  animated30Elements.forEach(section => {
    observer30.observe(section);
  });
});